<script setup lang="ts">
import { toRef, watch } from 'vue';
import { SearchableSelect } from '@/components/ui/searchable-select';
import { useBankAccountSelect } from '@/composables/useBankAccountSelect';

const props = withDefaults(
  defineProps<{
    modelValue?: number | string | null;
    customerId?: number | string | null;
    disabled?: boolean;
    placeholder?: string;
    pageSize?: number;
    class?: any;
  }>(),
  {
    pageSize: 100,
  }
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: number | string | null): void;
  (e: 'change', bankAccount: any | null): void;
}>();

function onChangeValue(id: number | string | null) {
  const item =
    id != null
      ? bankAccounts.value.find((b: any) => b.id === id || String(b.id) === String(id))
      : null;
  emit('change', item ?? null);
}

const customerIdRef = toRef(props, 'customerId');
const modelValueRef = toRef(props, 'modelValue');

const { bankAccounts, loading, hasMore, fetchBankAccounts, loadMore, onSearch } =
  useBankAccountSelect({
    customerId: customerIdRef,
    selectedId: modelValueRef,
    pageSize: props.pageSize,
  });

watch(
  customerIdRef,
  val => {
    if (val) fetchBankAccounts();
  },
  { immediate: true }
);

defineExpose({
  bankAccounts,
  fetchBankAccounts,
});
</script>

<template>
  <SearchableSelect
    :model-value="modelValue"
    :options="bankAccounts"
    :loading="loading"
    :remote-search="true"
    :has-more="hasMore"
    :disabled="disabled || !customerId"
    :placeholder="placeholder"
    :class="props.class"
    value-prop="id"
    label-prop="bank_name"
    @update:model-value="emit('update:modelValue', $event)"
    @change="onChangeValue"
    @search-change="onSearch"
    @load-more="loadMore"
  />
</template>
